import { TableHead } from '@roger/ui-components';
import { ChevronDown, ChevronUp } from 'lucide-react';

export type SortDirection = 'asc' | 'desc';

export interface ColumnSort<Column extends string> {
  column: Column;
  direction: SortDirection;
}

/** A table header that sorts its column when clicked, for server-sorted lists. */
export function SortableTableHead<Column extends string>({
  column,
  label,
  activeSort,
  onSort,
}: {
  column: Column;
  label: string;
  activeSort: ColumnSort<Column> | undefined;
  onSort: (column: Column) => void;
}) {
  const direction =
    activeSort?.column === column ? activeSort.direction : undefined;
  return (
    <TableHead
      aria-sort={
        direction === 'asc'
          ? 'ascending'
          : direction === 'desc'
            ? 'descending'
            : 'none'
      }
    >
      <button
        type='button'
        className='flex items-center hover:text-foreground transition-colors text-left font-medium'
        onClick={() => onSort(column)}
      >
        {label}
        {/* Both arrows stay visible so sortable columns are discoverable;
            the active direction darkens. */}
        <span className='ml-1 flex flex-col'>
          <ChevronUp
            className={`h-3 w-3 -mb-1 ${direction === 'asc' ? 'text-gray-600' : 'text-gray-300'}`}
          />
          <ChevronDown
            className={`h-3 w-3 ${direction === 'desc' ? 'text-gray-600' : 'text-gray-300'}`}
          />
        </span>
      </button>
    </TableHead>
  );
}
